import { Link } from "react-router-dom";
import { useTheme } from "@/lib/ThemeContext";

const GRACE_DAYS = 30;

// Bundle A-2: shown after self-service deletion (the session is already gone). A-3: 30-day grace period.
export default function AccountDeletedPage() {
  const { tokens: t } = useTheme();
  const purgeDate = new Date(Date.now() + GRACE_DAYS * 86400000).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" });
  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: t.bgPrimary, color: t.textPrimary }} data-testid="account-deleted-page">
      <div className="max-w-sm space-y-4">
        <h1 className="text-2xl font-bold">Your account has been deleted</h1>
        <p className="text-sm leading-relaxed" style={{ color: t.textMuted }} data-testid="account-deleted-grace">
          Your account will be permanently deleted on <span className="font-semibold" style={{ color: t.textPrimary }} data-testid="account-deleted-purge-date">{purgeDate}</span>. We've emailed you a link to restore it, should you change your mind before then.
        </p>
        <p className="text-sm leading-relaxed" style={{ color: t.textMuted }}>Thank you for spending some of your focus with us.</p>
        <Link to="/login" className="inline-block text-sm font-semibold hover:underline" style={{ color: t.accent }} data-testid="account-deleted-home-link">Back to the start</Link>
        <p className="text-xs" style={{ color: t.textMuted }}>Need to delete another account you can't sign in to? <Link to="/delete-account" className="underline" data-testid="account-deleted-delete-link">Use the deletion page</Link>.</p>
      </div>
    </div>
  );
}
